export default {
  // Loading text
  loading: "Loading...",

  // Titles and labels
  sharePermission: "Share Permission",
  validPeriod: "Valid Period",
  addressHiding: "Address Hiding",
  canvasData: "Canvas Data",
  shareLink: "Share Link",
  accessPassword: "Access Password",

  // Options
  viewOnlyOption: "View only (No login required, access with password)",
  copyableOption:
    "Copyable canvas (Access with password, users can copy canvas, login required)",

  // Valid period options
  day1: "1 Day",
  day3: "3 Days",
  day7: "7 Days",
  day14: "14 Days",
  day30: "30 Days",

  // Address hiding options
  no: "No",
  yes: "Yes",

  // Canvas data
  tag: "Tag",
  nodeComment: "Node Comment",
  showAll: "Show All",
  show: "Show",

  // Buttons
  copyLink: "Copy Link",
  confirm: "Confirm",

  // Messages
  expiredHint: "Valid period has expired, click the button below to reshare",
  copySuccess: "Copied successfully",

  // Copy text
  sharedCanvasFrom: "User uid{uid} shared the {canvasName} canvas with you",
  link: "Link: ",
  password: "Password: ",
  validityPeriod: "Valid Period: ",
  copyPermissionAllowed: "Copy Permission: Allowed",
  addressHidingYes: "Address Hiding: Yes",
  note: "Please note that this link has permission and validity period restrictions. Please make sure to enter the password within the validity period for access",

  // Placeholder
  pleaseSelect: "Please Select",
};
